"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.LinkImitation = exports.Inner = exports.CaptionText = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _types = require("../../types");
const Inner = exports.Inner = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, promoBannerType, isFocusPage } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        padding: theme.spacing(3),
        position: 'relative',
        ...isFocusPage ? {
            gap: theme.spacing(4)
        } : {
            gap: promoBannerType === _types.PromoBannerType.Text ? theme.spacing(3) : theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                gap: promoBannerType === _types.PromoBannerType.Text ? theme.spacing(4) : theme.spacing(3)
            }
        }
    };
});
const Title = exports.Title = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'promoBannerType',
        'isFocusPage'
    ])
})((param)=>{
    let { isFocusPage, promoBannerType } = param;
    return {
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: promoBannerType === _types.PromoBannerType.Text ? 5 : 2,
        WebkitBoxOrient: 'vertical',
        textAlign: 'center',
        ...isFocusPage ? {
            WebkitLineClamp: 3
        } : {}
    };
});
const LinkImitation = exports.LinkImitation = (0, _mui.styled)(_components.Button, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'promoBannerType',
        'isFocusPage'
    ])
})((param)=>{
    let { isFocusPage, promoBannerType, theme } = param;
    return {
        ...isFocusPage ? {} : {
            color: theme.palette.text.primary,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: theme.typography.fontWeightBold,
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitLineClamp: promoBannerType === _types.PromoBannerType.Text ? 2 : 1,
            WebkitBoxOrient: 'vertical',
            [theme.breakpoints.up('sm')]: {
                WebkitLineClamp: 2
            }
        }
    };
});
const CaptionText = exports.CaptionText = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        top: theme.spacing(0),
        right: theme.spacing(0),
        textAlign: 'right',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '1.2rem',
        padding: theme.spacing(1)
    };
});
